<script>
	import { block_special_characters, validate } from "$misc/actions";
	// import { compose, rightApply } from "$misc/utils";

	export let name = "name";
	export let value = "";
	export let label = "Label";
	export let placeholder = null;
	export let maxlength = 1000;
	export let required = true;
	export let asterisk = false;
	export let block = true;

	export const trigger = () => {
		const node = document.querySelector(`#${name}`);
		node.focus();
		node.blur();
	};

	const enhance = (node) => {
		block && block_special_characters(node);
		validate(node, "text");
	};
</script>

<div class="form-group">
	<label for={name} class:asterisk>{label}</label>

	<input
		use:enhance
		class="form-control"
		id={name}
		{name}
		type="text"
		placeholder={placeholder ?? label}
		{value}
		{required}
		{maxlength}
	/>
</div>

<style>
	label.asterisk::after {
		content: " *";
		color: red;
	}
</style>
